import React, {Component} from 'react';
import {NavLink} from 'react-router-dom';
import {Menu, Icon} from 'antd';
import {permissionCtrlHOC, getPDMSUrl} from "../../commons/CommonUtils";
import {Permissions, RolePermissions} from "../../commons/Constants";

const {SubMenu} = Menu;

const UrlMatrix = [
    {url: '/main/dashboard'},
    {url: '/main/tenant'},
    {url: '/main/upgrade-policy'},
    {url: '/main/mutitenantedservice'},
    {url: '/main/diagnostics'},
    {url: '/main/systemUsage'},
    {url: '/main/user'},
    {url: '/main/app-mgmt'},
    {parent: "sub1", url: '/main/kibana'}
];

class SideBar extends Component {

    render = () => {
        const {showMenu, width, userPermissions, currentURLPath, configs} = this.props;
        const menuMode = showMenu ? 'inline' : 'vertical';

        const path = UrlMatrix.filter((url) => currentURLPath.indexOf(url.url) >= 0);
        let currentKey = 0;
        let currentParent;
        if (path.length > 0) {
            currentKey = UrlMatrix.indexOf(path[0]);
            currentParent = path[0].parent;
        }
        const pdmsLink = configs.pdmsLink + "/api/rest/v1/user/login?tid="
            + sessionStorage.getItem('tenantId')
            + "&email=" + sessionStorage.getItem('username');

        let i = 0;

        return (
            <div className="ts-sidebar">
                <Menu style={{ width: width, height: "100%" }}
                      defaultSelectedKeys={[`${currentKey}`]}
                      defaultOpenKeys={currentParent ? [currentParent] : []}
                      mode={menuMode} theme='light'>

                    <Menu.Item key={i} title="Dashboard">
                        <NavLink to={UrlMatrix[i++].url} activeClassName="active">
                            <i className="pholio-left-menu-icon dashboard"></i>
                            {showMenu ? "Dashboard" : ""}
                        </NavLink>
                    </Menu.Item>

                    {permissionCtrlHOC([Permissions.TenantManager.SHOW], userPermissions)(
                        <Menu.Item key={i} title="Tenant">
                            <NavLink to={UrlMatrix[i++].url} activeClassName="active">
                                <i className="pholio-left-menu-icon authentication-p"></i>
                                {showMenu ? "Tenant" : ""}
                            </NavLink>
                        </Menu.Item>
                    )}

                    {permissionCtrlHOC([Permissions.SoftwareUpgrade.SHOW], userPermissions)(
                        <Menu.Item key={i} title="Software Upgrade">
                            <NavLink to={UrlMatrix[i++].url} activeClassName="active">
                                <i className="pholio-left-menu-icon devices-m"></i>
                                {showMenu ? "Software Upgrade" : ""}
                            </NavLink>
                        </Menu.Item>
                    )}

                    {permissionCtrlHOC([Permissions.MultiTenant.SHOW], userPermissions)(
                        <Menu.Item key={i} title="Services">
                            <NavLink to={UrlMatrix[i++].url} activeClassName="active">
                                <i className="pholio-left-menu-icon integrated-s"></i>
                                {showMenu ? "Services" : ""}
                            </NavLink>
                        </Menu.Item>
                    )}
                    {permissionCtrlHOC([Permissions.Diagnostics.SHOW], userPermissions)(
                        <Menu.Item key={i} title="Diagnostics">
                            <NavLink to={UrlMatrix[i++].url} activeClassName="active">
                                <i className="pholio-left-menu-icon diagnostics"></i>
                                {showMenu ? "Diagnostics" : ""}
                            </NavLink>
                        </Menu.Item>
                    )}
                    {permissionCtrlHOC([Permissions.SystemUsage.SHOW], userPermissions)(
                        <Menu.Item key={i} title="System Usage">
                            <NavLink to={UrlMatrix[i++].url} activeClassName="active">
                                <i className="pholio-left-menu-icon system-usage"></i>
                                {showMenu ? "System Usage" : ""}
                            </NavLink>
                        </Menu.Item>
                    )}
                    {permissionCtrlHOC([Permissions.User.SHOW], userPermissions)(
                        <Menu.Item key={i} title="User Management">
                            <NavLink to={UrlMatrix[i++].url} activeClassName="active">
                                <i className="pholio-left-menu-icon user-management"></i>
                                {showMenu ? "User Management" : ""}
                            </NavLink>
                        </Menu.Item>
                    )}
                    {permissionCtrlHOC([Permissions.AppVault.SHOW], userPermissions)(
                        <Menu.Item key={i} title="App Vault">
                            <NavLink to={UrlMatrix[i++].url} activeClassName="active">
                                <Icon type="appstore-o" />
                                {showMenu ? "App Vault" : ""}
                            </NavLink>
                        </Menu.Item>
                    )}

                    <SubMenu key="sub1" title={
                        <div>
                            <i className="pholio-left-menu-icon integrated-a"></i>
                            {showMenu ? "Others" : ""}
                            {showMenu && <div style={{display:'inline',float:'right'}}><Icon type="caret-down" /><Icon type="caret-up" /></div>}
                        </div>
                    }>
                        {permissionCtrlHOC(RolePermissions.Operator, userPermissions)(
                            <Menu.Item key={i} title="Device Dashboard">
                                <NavLink to={UrlMatrix[i++].url} title="Device Dashboard">
                                    Device Dashboard
                                </NavLink>
                            </Menu.Item>
                        )}
                        {configs.showPdms && permissionCtrlHOC([Permissions.TenantManager.SHOW,
                            Permissions.SoftwareUpgrade.SHOW, Permissions.PDMS.SHOW], userPermissions)(
                            <Menu.Item key={i++} title="PDMS Management">
                                <a href={pdmsLink}>
                                    PDMS Management
                                </a>
                            </Menu.Item>
                        )}
                        {configs.showTempPdms && permissionCtrlHOC([Permissions.TenantManager.SHOW,
                            Permissions.SoftwareUpgrade.SHOW], userPermissions)(
                            <Menu.Item key={i++} title="PDMS Dev">
                                <a href={getPDMSUrl('-dev')} style={{textDecoration:'line-through'}}>
                                    PDMS Dev
                                </a>
                            </Menu.Item>
                        )}
                    </SubMenu>
                </Menu>
            </div>
        );
    }
}

export default SideBar;


// WEBPACK FOOTER //
// ./src/modules/main/SideBar.js